import _ from "lodash";
import { computed, defineComponent, PropType, reactive, toRefs, watch, onMounted } from "vue";
import { message } from "ant-design-vue";
import FileStatus from "./file-status.vue";
import { FileUploadService } from "@/core";
import { generateUuid, getFileExt } from "@/utils";
import { FileRecord, UploadStatus } from "@/core/services/file-upload.interface";
import { columns } from "./multiple-file-upload.constant";
import { notifyEmitter } from "@/utils/emitter";
/**
 * TODO: 此组件未完成
 */
export default defineComponent({
  isGlobal: true,
  name: "MultipleFileUpload",
  components: { FileStatus },
  props: {
    value: {
      type: Array as PropType<FileRecord[]>,
      default: () => [],
    },
    uploadedCount: {
      type: Number,
      default: 0,
    },
    uploadButtonText: {
      type: String,
      default: "上传附件",
    },
    maxCount: {
      type: Number,
      default: 100,
    },
    maxSize: {
      type: Number,
      default: 100, // 100M
    },
  },
  emits: ["ok", "update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      uploading: boolean;
      visible: boolean;
      fileList: FileRecord[];
    }>({
      uploading: false,
      visible: false,
      fileList: [],
    });

    const maxSizeByte = computed(() => {
      return props.maxSize * 1024 * 1024;
    });

    const disabled = computed(() => {
      const rest = props.maxCount - props.uploadedCount;
      return rest <= 0;
    });

    const setFileStatus = (uid, status) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.status = status;
        }
        return item;
      });
    };

    const setFileUrl = (uid, url) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.url = url;
        }
        return item;
      });
    };

    const beforeUpload = (file) => {
      if (file.size > maxSizeByte.value) {
        message.warning(`单个文件不得超过${props.maxSize}M`);
        return false;
      }
      // return false;
    };

    const customRequest = async ({ file }) => {
      state.uploading = true;
      const fileRecord = new FileRecord();
      fileRecord.merge({
        uid: file.uid,
        name: file.name,
        suffix: getFileExt(file.name),
        size: file.size,
        url: "",
        status: UploadStatus.UPLOADING,
      });
      state.fileList.push(fileRecord);

      const url = await FileUploadService.uploadToOss(file);
      if (url) {
        setFileUrl(file.uid, url);
        setFileStatus(file.uid, UploadStatus.SUCCESS);
      } else {
        setFileStatus(file.uid, UploadStatus.FAIL);
      }
      state.uploading = false;
    };

    const deleteFile = (file: FileRecord) => {
      state.fileList = state.fileList.filter((item) => item.uid !== file.uid);
    };

    const showModal = () => {
      state.visible = true;
    };

    const closeModal = () => {
      state.visible = false;
      state.fileList = [];
    };

    const ok = () => {
      const _fileList = _.cloneDeep(state.fileList);
      emit("update:value", _fileList);
      const _newFileList = _fileList.filter((v) => {
        return props.value.findIndex((v1) => v1.uid === v.uid) === -1;
      });
      emit("ok", _newFileList);
      closeModal();
    };

    watch(
      () => props.value,
      (newValue) => {
        const files = newValue
          .filter((file) => !!file.url)
          .map((file) => {
            file.status = UploadStatus.SUCCESS;
            if (!file.uid) {
              file.uid = generateUuid();
            }
            return file;
          });
        if (files.length) {
          state.fileList = _.cloneDeep(files);
        }
      },
      { immediate: true }
    );
    onMounted(() => {
      notifyEmitter.all.delete("emit-notify");
      notifyEmitter.on("emit-notify", () => {
        state.fileList = [];
      });
    });
    return {
      ...toRefs(state),
      disabled,
      columns,
      beforeUpload,
      customRequest,
      deleteFile,
      showModal,
      closeModal,
      ok,
    };
  },
});
